import Modal from '../Modal';
import ResetPasswordForm from './ResetPasswordForm';
import { useSearchParams } from 'next/navigation';

export default function ResetPasswordModal() {
  const searchParams = useSearchParams();
  const showResetPasswordForm = searchParams.get('modal') === 'reset';
  return (
    <>
      {showResetPasswordForm && (
        <Modal>
          <ResetPasswordForm />
        </Modal>
      )}
    </>
  );
}
